'use client'
import { useContext } from 'react'
import MessagesContext from './MessagesContext'
export default function useMessageContext() {
  return useContext(MessagesContext)
}
